import React from 'react';

interface AstuteAccordionDescriptionHtmlProp {
    descriptions: (Element | null)[];
    indexNumber: number;
    nests: NodeListOf<Element> | undefined;
    descriptionsInnerHtml: number;
}

export const AstuteAccordionDescription = (
    props: AstuteAccordionDescriptionHtmlProp
) => {
    return (
        <>
            {props.nests && props.nests.length > 0 && (
                <div
                    dangerouslySetInnerHTML={{
                        __html:
                            props.descriptions[
                                props.indexNumber
                            ]?.innerHTML?.split(props.nests[0]?.outerHTML)[
                                props.descriptionsInnerHtml
                            ] || '',
                    }}
                />
            )}
        </>
    );
};
